import React, { useState } from "react";
import * as Icon from "../Map/smartiscity/Icons";
import ModelPreview from "./ModelPreview";
import styled, { css } from "styled-components";

const items = [
  {
    title: "Ιερός Ναός Αγίας Παρασκευής Μενεμένης",
    model: {
      name: "Αγία Παρασκευή Μενεμένη",
      url: "https://sketchfab.com/models/4fa89e55d6a54f3994f92d7b36658b19/embed?autostart=1&camera=0",
    },
  },
  {
    title: "Ιερός Ναός Αγίου Παντελεήμονα Αμπελοκήπων",

    model: {
      name: "Αγιος Παντελεημονας",
      url: "https://sketchfab.com/models/f0793ba0d0194bc98506cea299b41de2/embed?autostart=1&camera=0",
    },
  },
  {
    title: "Πολιτιστικό κέντρο Καραπάντσειο",
    model: {
      name: "Πολιτιστικό κέντρο Καραπάντσειο",
      url: "https://my.matterport.com/show/?m=mDfghLkPoWa",
    },
  },
];
const ThreeDimensionsPage = () => {
  const [selectedModel, setSelectedModel] = useState(items[0]);

  return (
    <PageWrapper>
      <PageContainer>
        <PageHeader>
          <img src={Icon.threeDGismo} alt="3d gismo icon" />
          <p>3D ΑΝΑΠΑΡΑΣΤΑΣΕΙΣ</p>
        </PageHeader>
        <ContentContainer>
          <MenuContainer>
            {items.map((item, id) => (
              <MenuItem
                $isItemSelected={item.title === selectedModel.title}
                onClick={() => {
                  setSelectedModel(item);
                }}
              >
                <MenuItemTitle>{item.title}</MenuItemTitle>
              </MenuItem>
            ))}
          </MenuContainer>
          <ModelPreview
            url={selectedModel.model.url}
            name={selectedModel.model.name}
          />
        </ContentContainer>
      </PageContainer>
    </PageWrapper>
  );
};

export default ThreeDimensionsPage;

const PageWrapper = styled.div`
  background-color: #191e25;
  width: 100%;
  height: 100%;

  @media only screen and (max-width: 500px) {
    overflow: scroll;
  }
`;

const PageContainer = styled.div`
  padding-top: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
`;

const BaseCss = css`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 20px;
  color: #fff;

  @media only screen and (max-width: 1200px) {
    flex-direction: column;
  }
`;

const PageHeader = styled.div`
  ${BaseCss}
  align-items: center;
`;

const ContentContainer = styled.div`
  ${BaseCss}
  align-items: flex-start;
`;

const MenuContainer = styled.div`
  width: 346px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media only screen and (max-width: 1200px) {
    width: 100%;
    flex-direction: row;
  }

  @media only screen and (max-width: 500px) {
    width: 96%;
    margin: 0 auto;
    flex-direction: column;
  }
`;

const MenuItem = styled.div`
  //   width: 100%;
  height: 112px;
  background-color: ${(props) =>
    props.$isItemSelected ? "#fff" : "#ffffff1f"};
  border-radius: 8px;
  border: ${(props) =>
    props.$isItemSelected ? "2px solid #fa6d65" : "2px solid transparent"};
  color: ${(props) => (props.$isItemSelected ? "#fa6d65" : "#fff")};
  cursor: pointer;
  transition: all 0.5s ease;
  &:hover {
    border: 2px solid #fa6d65;
    background-color: #0000005f;
    color: #fa6d65;
    transition: all 0.5s ease;
  }
`;

const MenuItemTitle = styled.p`
  margin: 10px auto;
  font-size: 16px;
  padding: 24px;
`;
